import React, {useEffect, useState } from 'react';
import { OfferProductionModel } from '../models/OfferProductionModel';

type InputProps = {
    messageTitle: string;
    ClosePopup: Function;
    onChange: Function;
    signingId: string;
}
const AssignToHandlerPopUp = (props: InputProps)=> {
    const offerProductionModel: OfferProductionModel = new OfferProductionModel();
    const [selectedHandlerId, setSelectedHandlerId] = useState<string | null>(null);
    const [selectedHandlerName, setSelectedHandlerName] = useState<string>('');
    const [handlersOptions, setHandlersOptions] = useState<any[]>([]);
    const closePopup = (status?: string)=>{
        if (props.ClosePopup) {
            props.ClosePopup(status);  
        }
    }

    const init = async () => {
        const signingUsersData = await offerProductionModel.getUserByRoleId();
        setHandlersOptions(signingUsersData.map((su: any)=> {
            return {
                label: su.fullName,
                value: su.id,
                active: su.status === 0
            }
        }));
    }

    const onSave = () => {
        // console.log('onSave');
        if (props.onChange && selectedHandlerId !== null) {
            props.onChange(selectedHandlerId);  
        }

    }
    const onHandlerChange = async (e: any) => {
        const handlerName = e.target.value;
        setSelectedHandlerName (handlerName);
        const selected = handlersOptions.find((a: any)=> a.label == handlerName);
        if(selected) {
            setSelectedHandlerId(selected.value);
        } else {
            setSelectedHandlerId(null)
        }
    }

    useEffect(()=>{
        init();
        // const creatorsListStr: string | null = localStorage.getItem('creatorsList');
        // if (creatorsListStr) {
        //     const creatorsList = JSON.parse(creatorsListStr)
        //     setHandlersOptions(creatorsList);
        //     console.log('creatorsList', creatorsList);
        // }
        
    }, [])

    return ( <>
        <div className={`popup-wrapper signings-config-popup small-warning`}>
            <section className="popup-window rtl">
                <div className="close-icon pointer" onClick={(e:any)=>closePopup()}></div>
                <div className="popup-content">
                    <div className="popup-header">
                        <div className="popup-title">
                            {props.messageTitle}
                        </div>
                    </div>
                    <div className="popup-body">
                        <div className={`client-tab-content client-details-edit-mode`}>
                            <div style={{flexGrow: 1, maxWidth: '400px'}}>
                                <div className="parameter-row">
                                    <div className={`parameter-item`}>
                                        <div className="field">
                                            <div className="title">
                                            שם חתם/ת:
                                            </div>
                                            <div className="value">
                                            <input type='text'
                                                      list="cretors_list"
                                                      placeholder='בחר חתם/ת'
                                                      onChange={(e: any)=>onHandlerChange(e)}
                                                      value={selectedHandlerName} 
                                                  />
                                            <datalist id="cretors_list">
                                                {handlersOptions && handlersOptions.map((c: any, i)=><option key={i} value={c.label}>{c.label}</option>)}
                                            </datalist>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="popup-footer">
                        <button className='button blue flex-centered flex-justify-center' onClick={onSave}>שייך</button>
                        <button className="button white blue-border pointer"  onClick={(e:any)=>closePopup()}>
                            סגור
                        </button>
                    </div>
                </div>
            </section>
        </div>
    </>  
        
    );
}
export default AssignToHandlerPopUp;